/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_A5Inputs */

const en_to_xml_faq_a5 = /** @type {(inputs: To_Xml_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON keys are converted to XML elements, not attributes. If you need attributes, you can manually edit the XML output after conversion.`)
};

const ko_to_xml_faq_a5 = /** @type {(inputs: To_Xml_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 키는 XML 속성이 아닌 요소로 변환됩니다. 속성이 필요한 경우 변환 후 XML 출력을 수동으로 편집할 수 있습니다.`)
};

const ja_to_xml_faq_a5 = /** @type {(inputs: To_Xml_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONキーは属性ではなくXML要素に変換されます。属性が必要な場合は、変換後にXML出力を手動で編集できます。`)
};

/**
* | output |
* | --- |
* | "JSON keys are converted to XML elements, not attributes. If you need attributes, you can manually edit the XML output after conversion." |
*
* @param {To_Xml_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_a5 = /** @type {((inputs?: To_Xml_Faq_A5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_A5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_a5(inputs)
	if (locale === "ko") return ko_to_xml_faq_a5(inputs)
	return ja_to_xml_faq_a5(inputs)
});